/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: s8ByeseNVHi6
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicPageInfoLine.module.css"; // plasmic-import: s8ByeseNVHi6/css

createPlasmicElementProxy;

export const PlasmicPageInfoLine__VariantProps = new Array();

export const PlasmicPageInfoLine__ArgProps = new Array("lineContent");

const $$ = {};

function PlasmicPageInfoLine__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          lineContent: "some text"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_cGVJnrZBpZGCmuty7FxDYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames("all", "__wab_text", sty.text)}
      >
        <React.Fragment>{$props.lineContent}</React.Fragment>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPageInfoLine__ArgProps,
          internalVariantPropNames: PlasmicPageInfoLine__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPageInfoLine__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPageInfoLine";
  } else {
    func.displayName = `PlasmicPageInfoLine.${nodeName}`;
  }
  return func;
}

export const PlasmicPageInfoLine = Object.assign(
  // Top-level PlasmicPageInfoLine renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicPageInfoLine
    internalVariantProps: PlasmicPageInfoLine__VariantProps,
    internalArgProps: PlasmicPageInfoLine__ArgProps
  }
);

export default PlasmicPageInfoLine;
/* prettier-ignore-end */
